import { CustomerStoriesDetailsHero as UniformCustomerStoriesDetailsHero } from "./customer-stories-details-hero";
export { CustomerStoriesDetailsHeroProps } from "./customer-stories-details-hero";

export default UniformCustomerStoriesDetailsHero;
